var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6728 12.7921C30.9507 9.68178 30.7751 4.53365 27.0874 1.63783C23.868 -0.828978 19.1267 -0.453594 16.1414 2.3886L15.0293 3.46113L13.8586 2.3886C11.4586 0.136295 6.6588 -1.25799 2.91258 1.63783C-0.775107 4.53365 -0.950711 9.68178 2.32723 12.7921L13.683 23.5174C14.0342 23.8391 14.5025 24 14.9707 24C15.4975 24 15.9658 23.8391 16.317 23.5174L27.6728 12.7921Z",
    fill: "#1066A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackHeart);
export default __webpack_public_path__ + "static/media/feedback-heart.44a51fac.svg";
export { ForwardRef as ReactComponent };